const MetaMiddleware = () => next => action => {
  const { meta } = action;
  if (!meta) return next(action);
  next(action);

  if (
    typeof meta.scrollTop === 'number' &&
    meta.scrollTop !==
      (window.pageYOffset || document.documentElement.scrollTop)
  )
    document.documentElement.scrollTop = meta.scrollTop;
};

export default MetaMiddleware;
